module.exports = __webpack_public_path__ + "static/img/banner-bg.29ae5cd4.png";